<template>
  <!-- 品牌信息 -->
  <div>
    <text-list-slot v-if="detail">
      <ul>
        <li>
          <span>品牌名称：</span>
          <span>{{detail.brandName}}</span>
        </li>
        <li>
          <span>运营企业：</span>
          <span>{{detail.brandOperation}}</span>
        </li>
        <li>
          <span>企业账户：</span>
          <span>{{detail.brandAccount}}</span>
        </li>
        <li>
          <span>随机密码：</span>
          <span>{{detail.brandPassword}}</span>
        </li>
        <li>
          <span>联系人：</span>
          <span>{{detail.brandContactPerson}}</span>
        </li>
        <li>
          <span>联系方式：</span>
          <span>{{detail.brandContactMobile}}</span>
        </li>
        <li>
          <span>联系地址：</span>
          <span>{{detail.brandAddress}}</span>
        </li>
      </ul>
      <ul>
        <li>
          <span>运维人数：</span>
          <span>{{detail.brandOperationNum}}<i @click="onShowDialog2('brandOperationNum')" class="blue ml8 cursor">详情</i></span>
        </li>
        <li>
          <span>自行车数：</span>
          <span>{{detail.brandBikeNum}}<i @click="onShowDialog2('brandBikeNum')" class="blue ml8 cursor">详情</i></span>
        </li>
        <li>
          <span>电动车数：</span>
          <span>{{detail.brandEBikeNum}}<i @click="onShowDialog2('brandEBikeNum')" class="blue ml8 cursor">详情</i></span>
        </li>
        <li>
          <span>投放范围：</span>
          <span>{{detail.launchAreaText}}</span>
        </li>
        <li>
          <span>运营范围：</span>
          <span>{{detail.operationAreaIdText}}</span>
        </li>
        <li>
          <span>归属范围：</span>
          <span>{{detail.areaIdText}}</span>
        </li>
      </ul>
      <ul>
        <li>
          <span>政府批文：</span>
          <span class="text-decoration cursor" @click="lookPDF(detail.brandApprovalUrl)">{{detail.brandApprovalName}}</span>
        </li>
        <li>
          <span>其他证明：</span>
          <span class="text-decoration cursor" @click="lookPDF(detail.otherUrl)">{{detail.otherName}}</span>
        </li>
      </ul>
    </text-list-slot>
    <div v-else>企业信息不存在！</div>
  </div>
</template>

<script>

import TextListSlot from '@/components/Listbox/textListSlot.vue'
import { lookPDF } from '@/utils/tools'
export default {
  name: 'text-list',
  props: ['detail'],
  data() {
    return {
    }
  },
  methods: {
    onShowDialog2(type) {
      this.$emit('onShowDialog2', type)
    },
    lookPDF(url) {
      lookPDF(url)
    },
    pageNoChange2(page) {

    },
    pageSizeChange2(size) {

    }
  },
  components: {
    TextListSlot
  }
}
</script>
